/**
 * Completing a Learn lesson changes challenge progress (`learning_lessons`
 * goals) — the challenge page showed "3 / 500" while the server had 4, because
 * completeLesson only invalidated the module lists. The Challenges tag is owned
 * by challengesApi (registered there with enhanceEndpoints), so the extra
 * invalidation is attached here rather than by editing either slice's types.
 */
import { api } from '../api';
import './learningApi';
import './challengesApi';

type TagList = unknown[];
type TagsField = TagList | ((...args: unknown[]) => TagList) | undefined;
interface MutableDefinition {
  invalidatesTags?: TagsField;
}
interface Enhanceable {
  enhanceEndpoints(options: { endpoints?: Record<string, (definition: MutableDefinition) => void> }): unknown;
}

export const LEARN_COMPLETION_INVALIDATES = ['Challenges'] as const;

(api as unknown as Enhanceable).enhanceEndpoints({
  endpoints: {
    completeLesson: (d) => {
      if (!d) return;
      const field = d.invalidatesTags;
      d.invalidatesTags = (...args: unknown[]) => {
        const base = typeof field === 'function' ? field(...args) : field ?? [];
        return [...base, ...LEARN_COMPLETION_INVALIDATES];
      };
    },
  },
});
